import usePermissions from './usePermissions';

// Features that are merged but not yet released to customers: only internal users see them.
// This is a visual gate: it controls whether a feature is shown to the user, but does not affect its functionality.
//
// To release a feature, delete its name from this list. The compiler then flags every
// usePreviewRelease call that still uses that name, so no gate is left behind by mistake.
export type PreviewRelease =
    // Choosing the baseline and comparison year for habitat trends.
    'habitatComparison';

// The name does not change the result: every preview release goes to internal users.
// It is there so the compiler can find each gate when the release is deleted above.
const usePreviewRelease = (_release: PreviewRelease): boolean => {
    const { isCurrentUserInternal } = usePermissions();
    return isCurrentUserInternal;
};

export default usePreviewRelease;
